<template>
  <div class="app-body-container" style="padding: 20px 0">
    <div class="report-content">

      <!--大数据预测销量-->
      <el-row :gutter="20" style="margin: 20px 0">
        <div class="disNone">
          <el-upload
            class="upload-demo"
            drag
            :action="largeData_url"
            v-loading.fullscreen.lock="fullscreenLoading"
            element-loading-text="数据分析中"
            :show-file-list="false"
            :before-upload="largeData_beforeUpload"
            :on-success="largeData_onSuccess">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text"><p style="padding-bottom: 10px;font-size: 24px">大数据预测销量</p>将文件拖到此处，或<em>点击上传</em></div>
            <!--<div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>-->
          </el-upload>
        </div>
        <el-col :span="24">
          <div class="grid-content bg-purple">
            <div v-if="largeData_showReport">
              <P class="text-center" style="padding: 10px 0 20px 0;font-size: 24px">{{largeData_title}}</P>
              <ve-line :data="largeData_chartData" :settings="largeData_chartSettings" :colors="largeData_colors"></ve-line>
            </div>
          </div>
        </el-col>
      </el-row>

      <!--按往年预测销量-->
      <el-row :gutter="20" style="margin: 20px 0">
        <div class="disNone">
          <el-upload
            ref="upPast"
            class="upload-demo"
            drag
            :action="pastYears_url"
            v-loading.fullscreen.lock="fullscreenLoading"
            element-loading-text="数据分析中"
            :show-file-list="false"
            multiple
            :auto-upload="false"
            :on-change="pastYears_onChange">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text"><p style="padding-bottom: 10px;font-size: 24px">按往年预测销量</p>将文件拖到此处，或<em>点击上传</em></div>
            <!--<div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>-->
          </el-upload>
        </div>
        <el-col :span="24">
          <div class="grid-content bg-purple">
            <div v-if="pastYears_showReport">
              <P class="text-center" style="padding: 10px 0 20px 0;font-size: 24px">{{pastYears_title}}</P>
              <ve-histogram :data="pastYears_chartData" :settings="pastYears_chartSettings"></ve-histogram>
            </div>
          </div>
        </el-col>
      </el-row>

    </div>
  </div>
</template>

<script>
  import VeLine from 'v-charts/lib/line'
  import VeHistogram from 'v-charts/lib/histogram'
  Vue.component(VeLine.name, VeLine)
  Vue.component(VeHistogram.name, VeHistogram)
  export default {
    data: function () {
        return {
            fullscreenLoading: false,
            // 大数据预测
            largeData_url:'',
            largeData_showReport:false,
            largeData_title:'',
            largeData_chartData:[],
            largeData_chartSettings:[],
            largeData_colors:[],
            // 往年
            pastYears_url:'',
            pastYears_showReport:false,
            pastYears_title:'',
            pastYears_chartData:[],
            pastYears_chartSettings:[],
            // 往年 - 上传文件
            pastYears_timeout: null,
            pastYears_isUp: false,
        }
    },
    methods: {
        getExtName: function(name){
            if (name && name.indexOf('.') >= 0) {
                var arr = name.toLowerCase().split('.');
                return arr[arr.length - 1]
            }
            return '';
        },
        // 大数据预测
        largeData_beforeUpload: function(file){
            let ext = this.getExtName(file.name);
            if(ext != 'csv' && ext != 'xls' && ext != 'xlsx'){
                this.xEui.msg_error('文件内容格式不正确，只能上传Excel文件');
                return false;
            }
            this.fullscreenLoading = true;
            return true;
        },
        largeData_onSuccess: function(res, file){
            this.fullscreenLoading = false;
            if(res.code != '00'){
                this.xEui.msg_error(res.text);
                return;
            }
            // 格式 { '日期': 'Nov-14', '预测销量': 1967, '上次销量': 1542}
            let rows = [];
            res.data.history.forEach(function(item,idx){
                rows.push({
                    '日期': item.date,
                    '预测销量': idx + 1 == res.data.history.length ? item.volume : '',
                    '上次销量': item.volume,
                });
            });
            res.data.future.forEach(function(item){
                rows.push({
                    '日期':item.date,
                    '预测销量':item.volume,
                    '上次销量':'',
                });
            });
            this.largeData_chartData = {
                columns: ['日期', '预测销量', '上次销量'],
                rows: rows
            };
            this.largeData_chartSettings = {
                metrics: ['预测销量', '上次销量',],
                dimension: ['日期'],
            };
            this.largeData_colors = ['red','#5ab1ef'];
            this.largeData_title = res.data.name;
            this.largeData_showReport = true;
        },
        // 往年
        pastYears_onChange: function (file, fileList) {
            let self = this;
            self.fullscreenLoading = true;
            //延迟处理
            if (self.pastYears_timeout) {
                clearTimeout(self.pastYears_timeout);
            }
            self.pastYears_timeout = setTimeout(function () {
                self.pastYears_startupload(fileList);
            }, 2500);
        },
        pastYears_startupload: function(fileList){
            let self = this;
            if (self.pastYears_isUp) {
                return;
            }
            self.pastYears_isUp = true;
            let stopUpload = function () {
                self.$refs.upPast.clearFiles();
                self.fullscreenLoading = false;
                self.pastYears_isUp = false;
            }

            console.log('uploading('+fileList.length+'个文件)...');

            // check file
            if(fileList.length ==0){
                stopUpload();
                return;
            }
            for(let i=0;i<fileList.length;i++){
                let f = fileList[i];
                let ext = self.getExtName(f.name);
                if (ext != 'csv' && ext != 'xls' && ext != 'xlsx') {
                    self.xEui.msg_error('文件内容格式不正确，只能上传Excel文件');
                    stopUpload();
                    return;
                }
            }

            // 上传
            var fd = new FormData();
            fileList.forEach(function(item){
                fd.append('files',item.raw);
            })
            self.xFetch.post(self.pastYears_url, fd, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            }).then(function(res){
                // 上传结果 START
                stopUpload();
                if (res.data.code != '00') {
                    self.xEui.msg_error(res.data.data || res.data.text);
                    return;
                }

                // 格式 [{ '日期': '1月', '16年销量': 2370.00, '17年销量':4737.00, '预测:18年销量':3054.00}]
                let rows = [],
                    history =  res.data.data.history,
                    future =  res.data.data.future;

                let hisYear1 = '', hisYear2 = '';
                history.forEach(function (item) {
                    let y = item.date.split('-')[0];
                    if (!hisYear1) hisYear1 = y;
                    else if (!hisYear2 && y != hisYear1) hisYear2 = y;
                })

                let fYear = '';
                future.forEach(function (item) {
                    let y = item.date.split('-')[0];
                    if (!fYear) fYear = y;
                })

                if(!hisYear1 || !hisYear2 || !fYear){
                    self.xEui.msg_error('预测数据异常');
                    return;
                }

                let getHis = function(date){
                    for(let i=0;i<history.length;i++){
                        if(history[i].date == date)
                            return parseFloat(history[i].volume);
                    }
                    return '';
                };
                let getF = function (date) {
                    for (let i = 0; i < future.length; i++) {
                        if (future[i].date == date)
                            return parseFloat(future[i].volume);
                    }
                    return '';
                };
                ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'].forEach(function (item) {
                    var num = parseInt(item);
                    var obj = {'日期': num + '月'};
                    obj[hisYear1 + '年销量'] = getHis(hisYear1 + '-' + item);
                    obj[hisYear2 + '年销量'] = getHis(hisYear2 + '-' + item);
                    obj['预测:' + fYear + '年销量'] = getF(fYear + '-' + item);
                    rows.push(obj);
                });

                self.pastYears_chartData = {
                    columns: ['日期', hisYear1 + '年销量', hisYear2 + '年销量', '预测:' + fYear + '年销量'],
                    rows: rows
                };
                self.pastYears_chartSettings = {
                    metrics: [hisYear1 + '年销量', hisYear2 + '年销量', '预测:' + fYear + '年销量'],
                    showLine: ['预测:' + fYear + '年销量']
                };
                self.pastYears_title = res.data.data.name;
                self.pastYears_showReport = true;
                // 上传结果 END
            })
        },
    },
    created: function () {
        // 上传地址
        this.largeData_url = this.xAppTool.apiWithToken('/robot/sales/largeDataForecast');
        this.pastYears_url = this.xAppTool.api('/robot/sales/pastYearsForecast');
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .report-content{
    padding: 10px;
    background: #ffffff;
    min-height: 840px;
  }
  .disNone{
    text-align: center;
  }
  .upload-demo .el-upload-dragger{ height: 240px }
</style>



// WEBPACK FOOTER //
// src/views/sale/sales-forecast.vue